import { render } from "./EmployeePersonalDetails.vue?vue&type=template&id=b6d78ace&scoped=true"
import script from "./EmployeePersonalDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePersonalDetails.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=b6d78ace&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d78ace"]])

export default __exports__